/**
 * Created by joli on 7/20/17.
 */

export const REQUEST_COMPANIES = "REQUEST_COMPANIES";
export const REQUEST_COMPANIES_SUCCESS = "REQUEST_COMPANIES_SUCCESS";
export const REQUEST_COMPANIES_FAILURE = "REQUEST_COMPANIES_FAILURE";

export const REQUEST_COMPANY_TEAMS = "RECEIVE_COMPANY_TEAMS";
export const REQUEST_COMPANY_TEAMS_SUCCESS = "REQUEST_COMPANY_TEAMS_SUCCESS";
export const REQUEST_COMPANY_TEAMS_FAILURE = "REQUEST_COMPANY_TEAMS_FAILURE";

export const REQUEST_COMPANY = "REQUEST_COMPANY";
export const REQUEST_COMPANY_SUCCESS = "REQUEST_COMPANY_SUCCESS";
export const REQUEST_COMPANY_FAILURE = "REQUEST_COMPANY_FAILURE";



// WEBPACK FOOTER //
// ./src/modules/companies/types.js